import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, timeout, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Functional interceptor:
 *  - credentials are attached ONLY to our own API, never to third-party hosts
 *  - every request is bounded by a timeout
 *  - raw server errors never reach the UI (no stack traces, versions or paths)
 */
export const securityInterceptor: HttpInterceptorFn = (req, next) => {
  const sameOrigin = req.url.startsWith('/') || req.url.startsWith(environment.apiUrl);

  const secured = req.clone({
    withCredentials: sameOrigin,
    setHeaders: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-store' }
  });

  return next(secured).pipe(
    timeout(15_000),
    catchError((err: HttpErrorResponse) =>
      throwError(() => ({
        status: err.status,
        message: err.status === 0
          ? 'Network unavailable. Please check your connection.'
          : 'Something went wrong. Please call +91 89836 43660.'
      }))
    )
  );
};
